/* Shlomoka: reveal-on-scroll. Content is visible without JS; reduced motion shows everything at once. */
(function () {
  var root = document.documentElement;
  function showAll() {
    root.classList.remove('sh-js');
  }
  try {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var designMode = root.classList.contains('shopify-design-mode');
    if (reduce || designMode || !('IntersectionObserver' in window)) {
      showAll();
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    function scan(scope) {
      (scope || document).querySelectorAll('.sh-rv:not(.in), .sh-hero h1:not(.in)').forEach(function (n) {
        io.observe(n);
      });
    }
    scan();
    document.addEventListener('shopify:section:load', function (ev) {
      scan(ev.target);
    });
    // Safety net: never leave content hidden if something goes wrong.
    window.setTimeout(function () {
      document.querySelectorAll('.sh-rv:not(.in), .sh-hero h1:not(.in)').forEach(function (n) {
        var r = n.getBoundingClientRect();
        if (r.top < window.innerHeight) n.classList.add('in');
      });
    }, 2500);
  } catch (err) {
    showAll();
  }
})();
